var ProcessInterpreter = require("../framework/Processes");
var Game = require("../framework/Game");
module.exports = new Game(ProcessInterpreter.getFormReaction);
